module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_06_stay-65c8e685a27d3c9d74754f957dabf8bf.jpg";